<template>
  <div class="reviewFailedDialog">
    <el-dialog :close-on-click-modal="false" :visible.sync="_visible" title="不通过原因" width="400px" @close="closeDialog">
      <el-form ref="handleForm" label-position="right" label-width="100px" :model="submitForm" :rules="handleRules">
        <el-form-item label="不通过原因" prop="failCause">
          <el-input v-model="submitForm.failCause" name="failCause" type="textarea" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="closeDialog">
          取消
        </el-button>
        <el-button type="primary" size="medium" @click="submitReviewFailed">
          提交
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { reviewFailed } from '@/api/messageCenter/index.js';
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true
    },
    templateId: {
      type: String,
      default: '',
      required: true
    }
  },
  data() {
    return {
      submitForm: {
        templateId: '',
        failCause: ''
      },
      viewData: {},
      handleRules: {
        failCause: [
          { required: true, message: '原因不能为空', trigger: 'blur' }
        ]
      }
    };
  },
  computed: {
    _visible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      }
    }
  },
  mounted() {
  },
  methods: {
    closeDialog() {
      this._visible = false;
    },
    submitReviewFailed() {
      this.submitForm.templateId = this.templateId;
      this.$refs['handleForm'].validate(valid => {
        if (valid) {
          reviewFailed(this.submitForm).then(res => {
            this.$notify.success({ title: 'Success', message: '操作成功', showClose: false, duration: 2000 });
            this.closeDialog();
            this.$emit('refreshList');
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.reviewFailedDialog{

}
</style>
